import {
  Avatar,
  Box,
  Button,
  Collapse,
  HStack,
  useColorModeValue,
  useDisclosure,
} from "@chakra-ui/react";
import Dialog from "@components/Dialog/Dialog";
import { NextImage } from "@components/NextImage/NextImage";
import { useToggleTheme } from "@components/ToggleTheme";
import { walletAddressPreview } from "@models/utils";
import { logOut, useUserStore } from "@providers/auth";
import {
  CloseIcon,
  LogoMobile,
  LogoutMenuIcon,
  MenuIcon,
} from "components/Icon";
import NavBar from "components/NarBar/NavBar";
import { MoongateLogoDarkMode, MoongateLogoLightMode } from "public";
import { useState } from "react";

const Header = ({ maxWidth: maxWidth = 1280 }: { maxWidth?: number }) => {
  const user: any = useUserStore((state) => state.user);
  const { isOpen, onToggle } = useDisclosure();
  const toggleTheme = useToggleTheme();
  const [confirmLogout, setConfirmLogout] = useState(false);
  const [processing, setProcessing] = useState(false);

  const name = () => {
    if (user?.email) {
      return user?.email;
    }
    return walletAddressPreview(
      user?.username || user?.wallets[0]?.addressPreview || ""
    );
  };

  const textColor = useColorModeValue("#23262F", "#DEDEE0");
  const btnLogOutColor = useColorModeValue("#777E90", "#DEDEE0");
  const handleLogoutPress = () => setConfirmLogout(true);

  return (
    <>
      <div
        style={{
          background:
            "linear-gradient(219deg, rgba(20, 160, 233, 0.5) 0%, rgba(22, 247, 232, 0.5) 100%)",
        }}
      >
        <Box
          as="header"
          className="mx-auto pb-8 pt-4 px-6 sm:px-0 sm:py-4 flex flex-row items-center justify-between w-full z-50"
          maxW={`${maxWidth}px`}
        >
          <>
            <div className="-mobile" style={{ color: "#45BFB0" }}>
              <LogoMobile />
            </div>
            <NextImage
              className="-desktop w-56"
              src={useColorModeValue(
                MoongateLogoLightMode,
                MoongateLogoDarkMode
              )}
              alt="moongate"
              layout="responsive"
            />
          </>

          <HStack>
            {user && (
              <Button
                background="rgba(255, 255, 255, 0.50)"
                size="md"
                variant="outline"
                leftIcon={<Avatar size="xs" name={name()} />}
                style={{ backgroundColor: "rgba(255,255,255,0.5)" }}
              >
                <p className={`text-xs text-[${textColor}]`}>{name()}</p>
              </Button>
            )}
            <div className="-mobile">
              {/* {user && ( */}
              {/*   <Button */}
              {/*     size="md" */}
              {/*     variant="outline" */}
              {/*     onClick={onToggle} */}
              {/*     background="rgba(255, 255, 255, 0.50)" */}
              {/*   > */}
              {/*     {!isOpen ? ( */}
              {/*       <MenuIcon boxSize="20px" /> */}
              {/*     ) : ( */}
              {/*       <CloseIcon boxSize="20px" /> */}
              {/*     )} */}
              {/*   </Button> */}
              {/* )} */}
              {user && (
                <Button
                  background="rgba(255, 255, 255, 0.50)"
                  size="md"
                  variant="outline"
                  ml={2}
                  onClick={handleLogoutPress}
                  style={{ backgroundColor: "rgba(255,255,255,0.5)" }}
                >
                  <LogoutMenuIcon width={6} height={6} color={btnLogOutColor} />
                </Button>
              )}
            </div>
            <div className="-desktop">
              {/* <Button */}
              {/*   size="md" */}
              {/*   variant="outline" */}
              {/*   onClick={toggleTheme} */}
              {/*   background="rgba(255, 255, 255, 0.50)" */}
              {/* > */}
              {/*   {useColorModeValue( */}
              {/*     <MoonIcon boxSize="20px" />, */}
              {/*     <SunIcon boxSize="20px" /> */}
              {/*   )} */}
              {/* </Button> */}
              {user && (
                <Button
                  background="rgba(255, 255, 255, 0.50)"
                  size="md"
                  variant="outline"
                  ml={2}
                  onClick={handleLogoutPress}
                  style={{ backgroundColor: "rgba(255,255,255,0.5)" }}
                >
                  <LogoutMenuIcon width={6} height={6} color={btnLogOutColor} />
                </Button>
              )}
            </div>
          </HStack>
        </Box>
      </div>
      {/* <div className="-mobile"> */}
      {/*   {user && ( */}
      {/*     <Collapse in={isOpen}> */}
      {/*       <NavBar /> */}
      {/*     </Collapse> */}
      {/*   )} */}
      {/* </div> */}
      <Dialog
        isOpen={confirmLogout}
        onClose={() => setConfirmLogout(false)}
        title="Confirm Logout"
        loading={processing}
        actions={[
          {
            text: "Cancel",
            onClick: () => {
              setConfirmLogout(false);
            },
          },
          {
            text: "Confirm",
            primary: true,
            onClick: () => {
              setProcessing(true);
              logOut();
            },
          },
        ]}
      >
        <div className="text-center">Are you sure you want to logout?</div>
      </Dialog>
    </>
  );
};
export default Header;
